/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement, useState, useContext } from 'react';
import { Field, useFormikContext } from 'formik';
import { TileRadioAccessible, TextInput, Modal, Button } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import { tile } from '@interfaces/interfaces';
import { iCourtFormValues } from '@services/CourtService';
import emailNotif from '../../../../images/emailviewv2.png';
import mobileNotif from '../../../../images/mobileview.png';
import styles from './InfringementExtStep4.module.scss';

function InfringementExtStep4(): ReactElement {
  const { values }: { values: iCourtFormValues } = useFormikContext();
  const currentDate = new Date();
  const expiryDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 7).toLocaleDateString('en-AU', { timeZone: 'Australia/Melbourne' });
  const [isOpenHelp, setOpenHelp] = useState(false);
  const [isNotifyHelp, setNotifyHelp] = useState(false);
  const closeNotifications = (modalName: string) => {
     if (modalName === 'savedForm') {
      setOpenHelp(false);
     } else {
     setNotifyHelp(false);
     }
  };

  const TILE_DATA: tile[] = [
    {
      body: 'Yes',
      value: 'true',
    },
    {
      body: 'No',
      value: 'false',
    },
  ];

  const TILE_DATA_NOTIFICATION_TYPE: tile[] = [
    {
      body: 'No thanks',
      value: 'none',
    },
    {
      body: 'To my mobile',
      value: 'mobile',
    },
    {
      body: 'To my email',
      value: 'email',
    },
    {
      body: 'To both',
      value: 'both',
    },
  ];
  const howDoaccessSavedForm = (): ReactElement => (
    <>
      <div>
        <div>Visit fines.vic.gov.au, and click the ‘Your Fines’ link in the top right.
        </div>
        <br />
        <div>Enter your fine’s Obligation or Infringement number (these details are printed on your fine). You may also be asked to enter some other details about yourself, your licence or your vehicle.</div>
        <br />
        <div>Once you’ve logged in, under ‘Started applications’ you will see your incomplete form listed. Click the ‘Resume’ button to access your form.</div>
        <br />
      </div>
    </>
  );
  const notificationInformation = (): ReactElement => (
    <div style={{ width: '100%' }}>
      <div className={styles.bitmapSection}>
        <span className={styles.bitmapTitle}>Email notification</span>
        <span className={styles.bitmapTitle}>Mobile notification</span>
        <div className={styles.bitmapImage}>
          <img className={styles.image} src={emailNotif} alt="email notification view" />
        </div>
        <div className={styles.bitmapImage}>
          <img className={styles.image} src={mobileNotif} alt="mobile notification view" />
        </div>
      </div>
    </div>
  );

  return (
    <div className={gridStyles.form}>
      <span className="vfH2">Save the form as you go?</span>
      <div className={gridStyles.gridColFull}>
        <div className="subHeadingH3">If you select Yes, we will save the form as you fill it in, so you can close it and come back later.</div>
      </div>
      <div className={gridStyles.gridColFull}>
        <div className={styles.col}>
          <Field name="SaveYesNo" component={TileRadioAccessible} tileData={TILE_DATA} orientationRow />
        </div>
      </div>
      <p>
        Your details on the form will be saved securely until submitted. To access a saved form go to the ‘Your Fines’ section on this website and log in using the fine’s obligation/infringement number.
      </p>
      <p>
        Remember, you must apply within 14 days of becoming aware of the fine. Your fine will continue to progress until you submit your application and receive a submission number.
      </p>
      <Button className={styles.modalLink} onClick={() => setOpenHelp(true)} size="small">
        How do I access my saved form later?
      </Button>
      {isOpenHelp && <Modal close={() => closeNotifications('savedForm')} show title="How do I access my saved form later?" content={howDoaccessSavedForm()} />}
      {values.SaveYesNo === 'true' && (
        <>
          <span className="vfH2">Send reminders of incomplete forms?</span>
          <div>We can send you a notification to remind you to come back and submit the application.</div>
          <Field name="SaveOptions" component={TileRadioAccessible} tileData={TILE_DATA_NOTIFICATION_TYPE} orientationRow />
          {(values.SaveOptions === 'email' || values.SaveOptions === 'both') && (
            <Field name="saveEmail" title="Email Address" component={TextInput} isMandatory />
          )}
          {(values.SaveOptions === 'mobile' || values.SaveOptions === 'both') && (
            <Field name="saveMobile" title="Mobile Number" component={TextInput} isMandatory />
          )}
          <Button className={styles.modalLink} onClick={() => setNotifyHelp(true)} size="small">
            What will my notifications look like?
          </Button>
          {isNotifyHelp && <Modal close={() => closeNotifications('myNotify')} show title="What will my notifications look like?" content={notificationInformation()} />}
        </>
      )}
    </div>
  );
}

export default InfringementExtStep4;
